import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var WhyOrderCancelledIA = function WhyOrderCancelledIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.Account.NOT_OPEN ? articlePage(articles.Account.NOT_OPEN.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize), IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "JDvEit",
    defaultMessage: [{
      "type": 0,
      "value": "Accounts moeten zijn geverifieerd om bestellingen van merken op Faire te ontvangen"
    }]
  });
};
var WE_VERIFY_ALL_NEW_ACCOUNTS = function WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize) {
  return strictLocalize({
    id: "3HQ2jm",
    defaultMessage: [{
      "type": 0,
      "value": "We verifiëren alle nieuwe accounts om een veilige marktplaats te behouden. Als je account niet kan worden geverifieerd, worden lopende bestellingen geannuleerd. Er worden geen kosten in rekening gebracht."
    }]
  });
};
var IF_YOU_HAVE_ANY_QUESTIONS = function IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize) {
  return strictLocalize({
    id: "WVf5FE",
    defaultMessage: [{
      "type": 0,
      "value": "Als je vragen hebt, neem dan contact met ons op en we nemen zo snel mogelijk contact met je op."
    }]
  });
};